import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Redo(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 24 24">
      <path d="M20.125 9.5H15.125C14.7734 9.5 14.5 9.22656 14.5 8.875C14.5 8.5625 14.7734 8.25 15.125 8.25H18.4844C17.1953 6.02344 14.7734 4.5 12 4.5C7.85938 4.5 4.5 7.85938 4.5 12C4.5 16.1406 7.85938 19.5 12 19.5C14.6172 19.5 16.9609 18.1328 18.2891 16.1016C18.4062 15.9062 18.6406 15.75 18.875 15.75C19.3438 15.75 19.6562 16.2578 19.3828 16.6875C17.8594 19.1484 15.0859 20.75 12 20.75C7.15625 20.75 3.25 16.8438 3.25 12C3.25 7.19531 7.15625 3.25 12 3.25C15.1641 3.25 17.9375 4.96875 19.5 7.50781V3.875C19.5 3.5625 19.7734 3.25 20.125 3.25C20.4375 3.25 20.75 3.5625 20.75 3.875V8.875C20.75 9.22656 20.4375 9.5 20.125 9.5Z" />
    </IconSvg>
  );
}
